import type { SwornData, Blessing, FaeKey } from "../types";
import SWORN_DATA_IMPORT from "../data.json";

export const SWORN_DATA: SwornData = SWORN_DATA_IMPORT as unknown as SwornData;

export const FAE_KEYS = Object.keys(SWORN_DATA.fae_lords) as FaeKey[];

export const ALL_BLESSINGS_MAP = new Map<string, Blessing & { fae: FaeKey }>();
(Object.keys(SWORN_DATA.fae_lords) as FaeKey[]).forEach(faeKey => {
    const faeData = SWORN_DATA.fae_lords[faeKey];
    const abilities = faeData.ability_blessings || [];
    const standards = faeData.standard_blessings || [];
    const duos = faeData.duo_blessings || [];
    const roundTables = faeData.round_table_blessings || [];
    const shrines = faeData.shrine_blessings || [];
    const all = [...abilities, ...standards, ...duos, ...roundTables, ...shrines];
    all.forEach(b => ALL_BLESSINGS_MAP.set(b.name, { ...b, fae: faeKey }));
});

export const FAE_COLORS = SWORN_DATA.fae_colors;